import React from 'react';
import RootRouter from './router';
import { BrowserRouter } from 'react-router';
import { AuthProvider } from './contexts/AuthContext';
import AppLayout from './layout/AppLayout';
import { addMissingAriaLabels } from './theme/heroui-config';
import { AccountProvider } from './contexts/AccountContext';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import { TranslationsContextProvider } from './contexts/translation.context';
import ru from './locales/ru.json';
import en from './locales/en.json';

const App = React.memo(() => {
  const [lang, setLang] = React.useState(localStorage.getItem('lang') || 'ru');
  const dictionary = React.useMemo(() => (lang === 'ru' ? ru : en), [lang]);

  const changeLanguage = React.useCallback((newLang: string) => {
    setLang(newLang);
    localStorage.setItem('lang', newLang);
  }, []);

  return (
    <BrowserRouter>
      <TranslationsContextProvider
        dictionary={dictionary}
        lang={lang}
        locales={['ru', 'en']}
        changeLanguage={changeLanguage}
      >
        <AuthProvider>
          <AccountProvider>
            <BreadcrumbProvider>
              <AppLayout>
                <RootRouter />
              </AppLayout>
            </BreadcrumbProvider>
          </AccountProvider>
        </AuthProvider>
      </TranslationsContextProvider>
    </BrowserRouter>
  );
});

App.displayName = 'App';

export default App;
